import { Chip } from '@c2fo/liquidity';
import { CloudUploadIcon, DownloadIcon } from '@c2fo/liquidity/icons';
import { StorageType as StorageTypeEnum } from '../../api/shared';

const getStorageTypeLabel = (type: StorageTypeEnum): string => {
  switch (type) {
    case StorageTypeEnum.STORAGE_TYPE_SFTP:
      return 'SFTP';
    case StorageTypeEnum.STORAGE_TYPE_FTP:
      return 'FTP';
    case StorageTypeEnum.STORAGE_TYPE_S3:
      return 'AWS S3';
    case StorageTypeEnum.STORAGE_TYPE_GCS:
      return 'GCP Storage';
    case StorageTypeEnum.STORAGE_TYPE_AZURE_BLOB:
      return 'Azure Blob';
    case StorageTypeEnum.STORAGE_TYPE_LOCAL:
      return 'Local';
    default:
      return 'Unknown';
  }
};

const getStorageTypeChipType = (type: StorageTypeEnum): 'primary' | 'secondary' | 'warning' => {
  switch (type) {
    case StorageTypeEnum.STORAGE_TYPE_S3:
    case StorageTypeEnum.STORAGE_TYPE_GCS:
    case StorageTypeEnum.STORAGE_TYPE_AZURE_BLOB:
      return 'primary';
    case StorageTypeEnum.STORAGE_TYPE_SFTP:
    case StorageTypeEnum.STORAGE_TYPE_FTP:
      return 'secondary';
    default:
      return 'warning';
  }
};

const isCloudStorage = (type: StorageTypeEnum): boolean => {
  return [
    StorageTypeEnum.STORAGE_TYPE_S3,
    StorageTypeEnum.STORAGE_TYPE_GCS,
    StorageTypeEnum.STORAGE_TYPE_AZURE_BLOB,
  ].includes(type);
};

const isFileTransfer = (type: StorageTypeEnum): boolean => {
  return [StorageTypeEnum.STORAGE_TYPE_SFTP, StorageTypeEnum.STORAGE_TYPE_FTP].includes(type);
};

export const StorageTypeChip: React.FC<{ storageType: StorageTypeEnum }> = ({ storageType }) => {
  const type = storageType;
  const label = getStorageTypeLabel(type);
  const Icon = isFileTransfer(type) ? DownloadIcon : isCloudStorage(type) ? CloudUploadIcon : null;

  return (
    <Chip
      label={
        <span className="inline-flex items-center gap-1">
          {Icon && <Icon className="h-3 w-3" />}
          {label}
        </span>
      }
      type={getStorageTypeChipType(type)}
      variant="outlined"
      size="xs"
    />
  );
};
